import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  flat?: boolean
}

export function Card({ flat = false, className, ...props }: CardProps) {
  return <div className={cn('aw-card', flat && 'flat', className)} {...props} />
}
